import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Product } from '@spike/product-model';
import { FunctionComponent } from 'react';
import Area from '../Area';
import ResumeSection, { BodyResumeSection } from '../ResumeSection';

interface Props {
    product: Product;
    onEdit: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0
        },
        row: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            [theme.breakpoints.down(768)]: {
                flexDirection: 'column',
                gap: '12px'
            }
        },
        item: {
            flex: '1 1 160px',
            minWidth: 0,
            maxWidth: '250px',
            [theme.breakpoints.down(768)]: {
                flex: '1 1 100%',
                maxWidth: '100%',
                marginRight: 0
            },
            [theme.breakpoints.between(768, 'md')]: {
                marginRight: '28px'
            },
            [theme.breakpoints.up('lg')]: {
                marginRight: '35px'
            }
        }
    })
);

const yesNo = (value?: boolean) => (value ? 'YES' : 'NO');

export const ResumeInventory: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const inventory = props.product.businessProduct?.inventory;

    return (
        <ResumeSection
            title="Inventory"
            onEdit={props.onEdit}
            product={props.product}
        >
            <BodyResumeSection>
                <Box className={classes.container}>
                    <Box className={classes.row}>
                        <Box className={classes.item}>
                            <Area
                                title="TRACK STOCK QUANTITY"
                                info={yesNo(inventory?.inventoryTracking !== false)}
                            />
                        </Box>
                        {inventory?.inventoryTracking !== false && (
                            <>
                                <Box className={classes.item}>
                                    <Area
                                        title="TRACKING METHOD"
                                        info={inventory?.trackBatches ? 'Track by Lots' : 'Track Total Stock'}
                                    />
                                </Box>
                                <Box className={classes.item}>
                                    <Area
                                        title="LOW STOCK NOTIFICATIONS"
                                        info={yesNo(inventory?.lowStockNotifications)}
                                    />
                                </Box>
                                {inventory?.lowStockNotifications && (
                                    <Box className={classes.item}>
                                        <Area
                                            title="LOW STOCK LEVEL"
                                            info={String(inventory.lowStockThreshold ?? 0)}
                                        />
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>
                </Box>
            </BodyResumeSection>
        </ResumeSection>
    );
};

export default ResumeInventory;
